<app-base-modal [isOpen]="isOpen" [withHeader]="false" (close)="onClose()">
  <div class="trial-subscription-modal">
    <img src="assets/icons/success.svg" alt="" class="trial-subscription-modal__icon" />

    <h1 class="h2">Trial subscription activated!</h1>

    <p>You now have access to a Trial subscription:</p>
    <p class="paper h4 trial-subscription-modal__conditions">7 days — 50 pages</p>
    <p>Just choose a number and the service is ready to go.</p>

    <button class="btn_primary btn_lg trial-subscription-modal__submit-button" (click)="onSubmit()">
      Proceed
    </button>
  </div>
</app-base-modal>
